import { memo } from 'react';
import { cn } from '@divlab/divanui';

import useTranslation from '@Queries/useTranslation';
import { useDeps } from '@Contexts/DI';
import ProductsSection from '@Components/ProductsSection';
import CrossSaleProductCard from '@Components/CrossSaleProductCard';
import Button from '@UI/Button';
import styles from './LandingProductsSection.module.css';

import type { FC, HTMLAttributes, ReactElement } from 'react';
import type { ProductData } from '@Types/Product';

export interface LandingProductsSectionProps extends HTMLAttributes<HTMLDivElement> {
  cnGallery?: string;
  cnSlide?: string;

  products: ProductData[];
  button?: { link: string; text?: string };
  analyticsTitle: string;
  withoutButton?: boolean;

  renderProduct?(product: ProductData): ReactElement;
}

const LandingProductsSection: FC<LandingProductsSectionProps> = (props) => {
  const {
    className,
    cnGallery,
    cnSlide,
    products,
    button,
    analyticsTitle,
    withoutButton,
    renderProduct,
    ...restProps
  } = props;
  const { t } = useTranslation();
  const { analytics } = useDeps();

  const handleClickSeeAll = () => {
    analytics.dispatchEvent('catalog.open', {
      action: 'show',
      label: analyticsTitle,
      targetPathname: button?.link,
    });
  };

  return (
    <div className={cn(styles.wrapper, className)} {...restProps}>
      <ProductsSection
        cnGallery={cnGallery}
        cnSlide={cnSlide}
        products={products}
        renderProduct={(product) =>
          renderProduct ? (
            renderProduct(product)
          ) : (
            <CrossSaleProductCard
              product={product}
              needBuyButton
              needComingSoonInfo
              hidenCreditTab
            />
          )
        }
        analyticsTitle={analyticsTitle}
      />

      {!withoutButton && (
        <div className={styles.container}>
          <Button
            className={styles.button}
            to={button?.link}
            theme='dirty'
            onClick={handleClickSeeAll}
          >
            {button?.text || t('ui.see-all')}
          </Button>
        </div>
      )}
    </div>
  );
};

export default memo(LandingProductsSection);
